<template>
    <van-popup v-model="isShow"
        position="bottom"
        :close-on-click-overlay="false"
        round
        :style="{ height: '65%', backgroundColor: '#f7f7f7', 'border-radius': '10px 10px 0 0' }">
        <div class="store-card-modal">
            <div class="title-contain">
                <div class="side"></div>
                <div class="middle">选择活动门店</div>
                <div class="side"
                    @click="closeModal">
                    <img class="close-img"
                        src="static/runtime/images/magic/close-icon2.png">
                </div>
            </div>
            <div class="search-contain">
                <div class="left">
                    <img class="search-img"
                        src="static/runtime/images/magic/search.png">
                </div>
                <div class="middle">
                    <input class="middle-input"
                        placeholder="搜索门店"
                        v-model="storeName">
                </div>
                <div class="right"
                    @click="searchStore()">搜索</div>
            </div>
            <div class="store-list"
                @scroll="handleScroll">
                <div v-for="item,index in storeList"
                    :key="item.channelCode"
                    :class="['store', item.channelCode === selectStoreCode? 'select-store':'unselect-store',index===0? 'first-store':'']"
                    @click="selectStore(item)">
                    <div :class="['store-left',item.distance?'store-narrow':'store-wide']">
                        <div class="top">{{item.channelName}}</div>
                        <div class="middle">{{item.channelAddress}}</div>
                        <div v-if="getWorkingHours(item)" class="open-hours">营业时间 {{getWorkingHours(item)}}</div>
                    </div>
                    <div v-if="item.distance"
                        class="store-right">距您{{item.distance}}km</div>
                    <div v-if="item.channelCode === selectStoreCode"
                        class="select-img-div">
                        <img class="select-img"
                            src="static/runtime/images/magic/select-tips.svg">
                    </div>
                </div>
                <div v-if="page.curPage === page.totalPages"
                    class="tips-div">~已加载全部门店~</div>
                <div class="bottom-div"></div>
            </div>
        </div>
    </van-popup>
</template>
<script>
let beforeScrollTop = 0;
import { Popup } from 'vant';
export default {
  components: { [Popup.name]: Popup },
  props: {
    // 活动编码
    activityCode: {
      type: String,
      default: '',
    },
    // 当前的门店
    currentStore: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //自定义表单url更换
    customFormFlag:{
       type: Boolean,
      default: false,
    }
  },
  watch: {
    currentStore: {
      handler(val) {
        this.selectStoreCode = val.channelCode;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      storeList: [],
      page: { curPage: 0, pageSize: 10, totalPages: 1 },
      params: { activityCode: '', longitude: '', dimension: '', channelName: '' },
      isShow: false,
      selectStoreCode: '',
      storeName: '',
      getStoreListDebounce: this.debounce(this.getStoreList),
      isRequesting:false, //是否正在请求门店列表接口
    };
  },
  computed: {},
  methods: {
    /**
     * 截取营业时间
     */
    getWorkingHours(item){
      const startTime =item.workStartTime && item.workStartTime.slice(10,19) 
      const endTime =item.workEndTime && item.workEndTime.slice(10,19)
      const workingTime = startTime +' ~'+ endTime
      return startTime&&endTime ?  workingTime : '';
    },
    /**
     * 搜索门店，且其他入参也要带入
     */
    searchStore() {
      if(this.isRequesting){
        return
      }
      this.page = { curPage: 0, pageSize: 10, totalPages: 1 };
      this.storeList = [];
      this.getStoreList();
    },
    /**
     * 打开弹窗，传入经纬度信息
     */
    openModal(param) {
      if(this.isRequesting){
        return
      }
      this.isShow = true;
      this.params = param;
      if (this.storeList && this.storeList.length === 0) {
        this.page = { curPage: 0, pageSize: 10, totalPages: 1 };
        this.getStoreList();
      }
    },
    // 关闭弹窗
    closeModal() {
      this.isShow = false;
    },
    // 获取门店列表
    getStoreList() {
      // 如果已经是最后一页了就不请求
      if (this.page.curPage === this.page.totalPages) {
        return;
      }
      
      this.isRequesting = true
      const params = {
        filter: { activityCode: this.activityCode },
        curPage: this.page.curPage + 1,
        pageSize: this.page.pageSize,
      };
      if (this.storeName) {
        params.filter.channelName = this.storeName;
      }
      if (this.params.longitude) {
        params.filter.longitude = this.params.longitude;
      }
      if (this.params.latitude) {
        params.filter.dimension = this.params.latitude;
      }
   
      let url='/bigWheel/selectChannelDetailByDraw';
      if(this.customFormFlag){
        url='questionActivity/selectStoreList'
      }
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: url,
        params,
        success: (res) => {
          console.log('getStoreList----------->',res);
          this.isRequesting = false
          if (res.code === 200 && res.result.length > 0) {
            this.page = {
              curPage: res.result[0].pagingMap.curPage,
              pageSize: res.result[0].pagingMap.pageSize,
              totalPages: res.result[0].pagingMap.totalPages,
            };
            this.storeList = this.storeList.concat(res.result);
          }          
        },
        failure: err => {
          this.isRequesting = false
        }
      });
    },
    handleScroll(e) {
      // 滚动处理方法
      // 距顶部
      const scrollTop = e.target.scrollTop;
      // 可视区高度
      const clientHeight = e.target.clientHeight;
      // 滚动条总高度
      const scrollHeight = e.target.scrollHeight;

      // 确定滚动方向
      let direction = 'down';
      if (beforeScrollTop > scrollTop) {
        direction = 'up';
      }

      // 通过滚动方向判断是触底还是触顶
      if (direction == 'down') {
        // 滚动触底
        if (scrollTop + clientHeight + 40 >= scrollHeight) {
          console.log('滚动触底');
          this.getStoreListDebounce();
        }
      } else {
        // 滚动到顶部
        if (scrollTop <= 40) {
          console.log('滚动到顶');
        }
      }
      beforeScrollTop = scrollTop;
    },
    debounce(func, duration = 700) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, duration);
      };
    },
    // 选择门店
    selectStore(item) {
      this.selectStoreCode = item.channelCode;
      this.$emit('changeStore', item);
      this.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.store-card-modal {
  border-radius: 5px 5px 0px 0px;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: #f7f7f7;
  .title-contain {
    border-radius: 5px 5px 0px 0px;
    width: 100%;
    height: 52px;
    background-color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .side {
      width: 27px;
      .close-img {
        width: 12px;
      }
    }
    .middle {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .search-contain {
    margin-left: 15px;
    margin-right: 15px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
    .left {
      width: 45px;
      display: flex;
      align-items: center;
      .search-img {
        width: 25px;
        margin-left: 6px;
        margin-right: 2px;
      }
    }
    .middle {
      border-right: #00000030 solid 1px;
      width: 100%;
      .middle-input {
        border: none;
        width: 100%;
      }
    }
    .right {
      width: 50px;
      text-align: center;
    }
  }
  .store-list {
    height: calc(100% - 104px);
    background-color: #f7f7f7;
    padding-left: 15px;
    padding-right: 15px;
    overflow-y: auto;
    .store {
      background-color: #fff;
      padding: 15px;
      padding-right: 0;
      display: flex;
      font-size: 12px;
      margin-top: 10px;
      border-radius: 5px;
      position: relative;
      .store-left {
        padding-right: 10px;
        .top {
          height: 20px;
          font-size: 16px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .middle {
          margin-top: 5px;
          color: #999;
        }
        .open-hours{
          color: #999;
          font-size: 12px;
        }
        .bottom {
          height: 12px;
          margin-top: 5px;
        }
      }
      .store-narrow {
        border-right: #00000030 solid 1px;
        width: calc(100% - 90px);
      }
      .store-wide {
        width: 100%;
      }
      .store-right {
        width: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .select-img-div {
        height: 23px;
        width: 23px;
        position: absolute;
        bottom: -1px;
        right: -1px;
        .select-img {
          height: 23px;
          width: 23px;
        }
      }
    }
    .first-store {
      margin-top: 0px;
    }
    .select-store {
      border: 1px solid #256fff;
    }
    .unselect-store {
      border: 1px solid #ffffff;
    }
    .tips-div {
      width: 100%;
      text-align: center;
      margin-top: 10px;
      color: #999;
    }
    .bottom-div {
      width: 100%;
      height: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/store-modal.vue